import { CompTypes } from '@/constants/CompTypes';
import { SourceDataInitials } from '@/constants/SourceDataInitials';
import IComp from '../Comp';
import IFeedData from './IFeedData';
import ISourceData from './ISourceData';

export default {
    getDataSourceFeedData(comp: IComp, initials: string): IFeedData | null {
        const feedData = getFeedDataByInitials(comp, initials);
        return feedData;
    },
    getDataSourceSourceData(comp: IComp, initials: string): ISourceData | null {
        const feedData = getFeedDataByInitials(comp, initials);
        if (feedData && feedData.sourceData) {
            return feedData.sourceData;
        }

        return null;
    },
    getDataSourceSubSourceData(comp: IComp, initials: string, subCompIdx: number): ISourceData | null {
        const feedData = getSubFeedDataByInitials(comp, initials, subCompIdx);
        if (feedData) {
            return feedData;
        }

        return null;
    },
    isSubject(comp: IComp): boolean {
        if (comp.compType && comp.compType.toLowerCase() == CompTypes.Subject.toLowerCase()) {
            return true;
        }
        return false;
    },
    shouldExport(comp: IComp): boolean {
        // All values are truthy unless they are defined as falsy
        // (i.e., except for false, 0, -0, 0n, "", null, undefined, and NaN).
        if (comp.hasVisited || this.isSubject(comp) || comp.compKey) {
            return true;
        }
        return false;
    },
};

function getFeedDataByInitials(comp: IComp, initials: string): IFeedData | null {
    let result: IFeedData | null = null;

    switch (initials.toLowerCase()) {
        case SourceDataInitials.Database:
            result = comp.sourceDataDB ?? null;
            break;
        case SourceDataInitials.PublicRecords:
            result = comp.sourceDataPR ?? null;
            break;
        case SourceDataInitials.SmartExchange:
            result = comp.sourceDataSE ?? null;
            break;
        case SourceDataInitials.Mls:
            result = comp.sourceDataMLS ?? null;
            break;
    }
    return result;
}

function getSubFeedDataByInitials(comp: IComp, initials: string, subCompIdx: number): IFeedData | null {
    let result: IFeedData | null = null;

    switch (initials.toLowerCase()) {
        case SourceDataInitials.Database:
            result = comp?.subCompData?.[initials][subCompIdx] ?? null;
            break;
        case SourceDataInitials.SmartExchange:
            result = comp?.subCompData?.[initials][subCompIdx] ?? null;
            break;
    }
    return result;
}
